import type { KPIRequest } from "@/types/kpiTypes.ts"

export const SagepointKPIs: KPIRequest[] = [
  {
    $type: "basic",
    id: 600,
    location: 1,
  },
  {
    $type: "basic",
    id: 610,
    location: 1,
  },
]
